<div class="wrapper-reset-password">
  <img class="login__logo" src="assets/logo.png" alt="Kaizen" />

  @if(!isOTPSent) {
  <h2 class="login__title">Reset Password</h2>
  <p class="login__subtitle">
    Enter your user name and we'll send you an OTP to reset
  </p>

  <form id="form-reset-password" class="login__form">
    <div class="login__field">
      <input
        type="text"
        class="login__input"
        placeholder="User Name*"
        [formControl]="userName"
        id="input-reset-user-name"
        autocomplete="username"
      />
      @if(userName.touched && userName.invalid) {
      <span class="login__field-error">{{ Messages.MSG_ERROR_REQUIRED }}</span>
      }
    </div>

    <div class="login__options login__options--row-end">
      <a class="login__forgot" routerLink="/login">Back to login</a>
    </div>

    <button
      type="button"
      class="login__btn"
      (click)="sendResetOTP()"
      [class.spinner]="isSendingOTP"
      [disabled]="isSendingOTP"
    >
      Send OTP
    </button>
  </form>
  } @else {
  <h2 class="login__title">Reset Password</h2>
  <p class="login__subtitle">Enter 6 digit OTP and new password</p>

  <div id="form-reset-password" class="login__form login__form--stack">
    <kzn-otp-input #otpInputComponentRef></kzn-otp-input>

    <div [formGroup]="passwordForm" class="login__form-fields">
      <div class="login__field">
        <input
          [type]="showPassword ? 'text' : 'password'"
          class="login__input login__input--with-toggle"
          placeholder="Password*"
          formControlName="newPassword"
          id="input-reset-new-password"
          autocomplete="new-password"
        />
        <button
          type="button"
          class="login__toggle-pw"
          (click)="togglePasswordVisibility()"
        >
          <mat-icon>{{ showPassword ? "visibility_off" : "visibility" }}</mat-icon>
        </button>
        @if(passwordForm.get('newPassword')?.touched &&
        passwordForm.get('newPassword')?.invalid) {
        <span class="login__field-error">{{ Messages.MSG_ERROR_REQUIRED }}</span>
        }
      </div>

      <div class="login__field">
        <input
          [type]="showConfirmPassword ? 'text' : 'password'"
          class="login__input login__input--with-toggle"
          placeholder="Confirm Password*"
          formControlName="confirmPassword"
          id="input-reset-confirm-password"
          autocomplete="new-password"
        />
        <button
          type="button"
          class="login__toggle-pw"
          (click)="toggleConfirmPasswordVisibility()"
        >
          <mat-icon>{{ showConfirmPassword ? "visibility_off" : "visibility" }}</mat-icon>
        </button>
        @if(passwordForm.get('confirmPassword')?.touched &&
        passwordForm.get('confirmPassword')?.invalid) { @if(
        passwordForm.get('confirmPassword')?.errors?.['required']) {
        <span class="login__field-error">{{ Messages.MSG_ERROR_REQUIRED }}</span>
        } @else {
        <span class="login__field-error">{{ Messages.MSG_ERROR_PASSWORD_MISMATCH }}</span>
        } }
      </div>
    </div>

    <button
      type="button"
      class="login__btn"
      (click)="resetPassword()"
      [class.spinner]="isResettingPassword"
      [disabled]="isResettingPassword"
    >
      Reset
    </button>
  </div>
  }
</div>
